<template>
  <div class="navbar">
    <div class="navbar-list" v-for="(list, index) in splitList" :key="index">
      <div class="navbar-item" v-for="item in list" :key="item.name" @click="goToPage(item)">
        <img v-if="channel == '002_11_0000_0000_00'" :src="item.zx_avatar" />
        <img v-else :src="item.avatar" />
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { OPERATION } from '@/assets/js/config'
import { isMiniProgram, toNucleicAcid } from '@/assets/js/util.js'
export default {
  name: "NavBar",
  props: {
    pageName: {
      type: String,
      default: "个检/首页",
    },
  },
  data() {
    return {
      list: OPERATION[ENTRY_CHANNEL[sessionStorage.getItem("channel")]] || OPERATION.default,
      channel: sessionStorage.getItem("channel")
    };
  },
  computed: {
    splitList() {
      // if (this.channel != '002_11_0000_0000_00' && this.isWxMiniProgram()) {
      //   this.list[0] = {
      //     avatar: "https://frontend-1251027788.cos.ap-guangzhou.myqcloud.com/tijian/daishu/images/icon_home_daoyuan_nor%402x.png",
      //     name: "核酸检测",
      //     route: `${ZTPREFIX}?channel=006_88_1111_0003_00`,
      //     zx_avatar: "https://frontend-1251027788.cos.ap-guangzhou.myqcloud.com/tijian/daishu/images/icon_home_daoyuan_nor%402x.png",
      //   }
      // }
      let res = [];
      this.list.reduce((acc, cur, index) => {
        acc.push(cur);
        if ((index + 1) % 4 === 0) {
          res.push(acc);
          return [];
        }
        if (index === this.list.length - 1) {
          res.push(acc);
        }
        return acc;
      }, []);
      return res;
    },
  },
  methods: {
    isWxMiniProgram() {
      return isMiniProgram()
    },
    goToPage(item) {
      this.$baiDuMtaEvent([this.pageName, `点击专题入口`, item.name, "-"]);
      // if (item.name === '核酸检测') {
      //   toNucleicAcid(item.route)
      // } else

      if (location.hostname.includes("test.")) {
        location.href = `//${location.hostname}${location.pathname}#${item.route}`;
      } else {
        location.href = `//${location.host}/wechat/h5#` + item.route;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navbar {
  // justify-content: space-between;
  width: 702/200rem;
  height: 320/200rem;
  background: #ffffff;
  border-radius: 20/200rem;
  padding: 20/200rem 32/200rem 36/200rem;
  .navbar-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    &:not(:first-child) {
      margin-top: 48/200rem;
    }
    .navbar-item {
      img {
        width: 72/200rem;
        height: 72/200rem;
        margin: 0 12/200rem 0 14/200rem;
      }
      p {
        margin-top: 12/200rem;
        font-size: 24/200rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #000000;
        line-height: 24/200rem;
      }
      // &:not(:first-child) {
      //   margin-left: 80/200rem;
      // }
    }
    // &:nth-child(5n) {
    //   margin-left: 0;
    // }
  }
}
</style>
